import type { ListProps } from '@mui/material';
import { List, ListItem, styled } from '@mui/material';

export interface LookoBulletListProps {
  items: string[];
}

/**
 * 불릿형 리스트.
 *
 * TODO: 스토리 작성.
 */
export const LookoBulletList = styled(({ items, ...props }: LookoBulletListProps & ListProps) => {
  return (
    <List {...props} dense disablePadding>
      {items.map((v, index) => {
        return <LookoBulletListItem key={index}>{v}</LookoBulletListItem>;
      })}
    </List>
  );
})({
  listStyleType: 'disc',
  paddingLeft: 16,
  '& .MuiListItem-root': {
    display: 'list-item',
  },
});

const LookoBulletListItem = styled(ListItem)({
  whiteSpace: 'pre-line',
  padding: 0,
});
